export const BASE_URL =  process.env.NODE_ENV === 'development' ? 'http://localhost:9090/api' : `${window.location.protocol}//${window.location.host}/api`;
export const APP_NAME = 'Ciena';
export const IS_LOGIN_ENABLED = process.env.VUE_APP_IS_LOGIN_ENABLED === 'true';
